import Grid from '@/global/components/ui/Grid'
import { FormDatePicker } from 'global/components/Form'
import { FormAutocompleteCentroCusto } from 'templates/Cadastro/CentroCusto/atoms/modals/Adicionar'

/** Campos de centro de custo enviados junto com o cadastro do funcionário. */
export function CentroCustoForm() {
    return (
        <section id="centro-custo">
            <Grid container>
                <Grid item xs={12}>
                    <FormAutocompleteCentroCusto className="flex-1" />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormDatePicker
                        name="FuncionarioCentroCusto.dtInicial"
                        label="Data inicial"
                        type="date"
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormDatePicker
                        name="FuncionarioCentroCusto.dtFinal"
                        label="Data final"
                        type="date"
                        helperText="Deixe em branco para indeterminado"
                    />
                </Grid>
            </Grid>
        </section>
    )
}
